// @see https://schema.org/Person
export const personType = name =>
  name
    ? {
        '@type': 'Person',
        name
      }
    : null;
